import { render, staticRenderFns } from "./modal4.vue?vue&type=template&id=08c8977c"
import script from "./modal4.vue?vue&type=script&lang=js"
export * from "./modal4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports